import { z } from 'my-zod'
import { outfitterDocumentModel } from './outfitter-document-model'
import { attachmentModel } from '../../utilities/attachment'

export const outfitterDocumentSystemView = outfitterDocumentModel
  .augment({
    attachment: attachmentModel
  })
  .setCFV(outfitterDocumentModel.getCFV())

export type outfitterDocumentSystemView = z.infer<typeof outfitterDocumentSystemView>
